import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { HomeComponent } from '../../home/home.component';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { PmsComponent } from '../../home/pms/pms.component';
import { AuthGuard } from '../services/app-guards.service';
import { CustomPreloadingStatergy } from '../services/pre-loading-startergy';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'app',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'pms', component: PmsComponent },
      { path: 'master', loadChildren: () => import('src/app/masters/masters.module').then(m => m.MastersModule), data: {} },
      { path: 'transaction', loadChildren: () => import('src/app/business-process/business-process.module').then(m => m.BusinessProcessModule), data: {} },
      { path: 'admin', loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule), data: {} },
      { path: 'report', loadChildren: () => import('src/app/reports/report.module').then(m => m.ReportModule), data: {} },
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: CustomPreloadingStatergy })
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard,
    CustomPreloadingStatergy
  ]
})
export class AppRoutingModule { }
